export enum AUTH_TPYE {
  PASSWORD = 1,
  PHONE = 2
}
